import React from 'react';
import Style from './index.module.scss';
import useModalHandler from '../../Utils/Hooks/useModalHandler';
import ImportLogModal from './Components/ImportLogModal';
import {WindowProps} from './service';

interface Props extends WindowProps {
    children?: React.ReactNode;
}
const Index = ({logUrl, downloadUrl, children}: Props) => {
    const modal = useModalHandler({
        component: ImportLogModal,
    });
    function openModal() {
        modal.open({
            logUrl,
            downloadUrl,
        });
    }
    return (
        <div className={Style.root}>
            {children && <div onClick={openModal}>{children}</div>}
            {!children && (
                <span className={Style.link} onClick={openModal}>
                    查看导入结果
                </span>
            )}

            {modal.render()}
        </div>
    );
};

export default Index;
